function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26418_8005)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.0059 0C49.9099 0 41.2939 2.1 33.6379 5.832C54.1459 19.608 83.2939 39.336 92.6059 45.732C95.7499 47.892 96.9379 51.96 95.4739 55.476L71.1979 114.78C97.3939 109.188 117.05 85.908 117.05 58.032C117.026 25.98 91.0459 0 59.0059 0Z",
  fill: "#1C9CE4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.922 63.024C65.702 59.1 63.47 55.2 59.702 53.868L5.714 35.028C2.666 42.084 0.973999 49.86 0.973999 58.02C0.973999 88.536 24.53 113.544 54.446 115.872L64.922 63.024Z",
  fill: "#1C9CE4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.982 64.8121C85.2508 64.8121 89.522 60.5409 89.522 55.2721C89.522 50.0033 85.2508 45.7321 79.982 45.7321C74.7132 45.7321 70.442 50.0033 70.442 55.2721C70.442 60.5409 74.7132 64.8121 79.982 64.8121Z",
  fill: "#1E66AE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.2899 120C66.259 120 68.6659 117.593 68.6659 114.624C68.6659 111.655 66.259 109.248 63.2899 109.248C60.3209 109.248 57.9139 111.655 57.9139 114.624C57.9139 117.593 60.3209 120 63.2899 120Z",
  fill: "#2799D5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.274 32.832C27.1341 32.832 33.506 26.4602 33.506 18.6C33.506 10.7399 27.1341 4.36804 19.274 4.36804C11.4139 4.36804 5.04199 10.7399 5.04199 18.6C5.04199 26.4602 11.4139 32.832 19.274 32.832Z",
  fill: "#214195"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26418_8005"
}, /*#__PURE__*/React.createElement("rect", {
  width: 116.052,
  height: 120,
  fill: "white",
  transform: "translate(0.973999)"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.b088ae3d.svg";
export { ForwardRef as ReactComponent };